import { useState } from "react";
import useLiveKitMediaError from "../../../hooks/useMediaPermissions";
import styles from "./StudioErrorsContainer.module.css";
import StudioError from "./src/StudioError";

const StudioErrorsContainer = () => {
  const { isAllowedAudio, isAllowedVideo, isLoading } = useLiveKitMediaError();
  const [closedErrors, setClosedErrors] = useState({
    audio: false,
    video: false,
  });

  if (isLoading) {
    return null;
  }

  const handleCloseAudioError = () => {
    setClosedErrors(prev => ({ ...prev, audio: true }));
  };

  const handleCloseVideoError = () => {
    setClosedErrors(prev => ({ ...prev, video: true }));
  };

  return (
    <div className={styles["studia-error-container__container"]}>
      {isAllowedAudio === false && !closedErrors.audio && (
        <StudioError
          header="Не подключен микрофон"
          content="Пожалуйста, проверьте подключение вашего микрофона или разрешение на его использование в браузере. Если вы используете ноутбук, убедитесь, что встроенный микрофон включен в настройках системы."
          onClose={handleCloseAudioError}
        />
      )}
      {isAllowedVideo === false && !closedErrors.video && (
        <StudioError
          header="Не подключена камера"
          content="Пожалуйста, проверьте подключение вашей камеры или разрешение на ее использование в браузере. Если вы используете ноутбук, убедитесь, что встроенная камера включена в настройках системы и не закрыта шторкой."
          onClose={handleCloseVideoError}
        />
      )}
    </div>
  );
};

export default StudioErrorsContainer;